import React from "react";
import PromotionsForm from "../components/PromotionsForm";

const Promotions = () => {
  return (
    <div>
      <PromotionsForm />
    </div>
  );
};

export default Promotions;
